export enum SyncItemsTypes {
    CheckListItem = "CheckListItem",
    PunchlistItem = "PunchlistItem",
    Comment = "Comment",
    CreateAdHocUnitItem = "CreateAdHocUnitItem",
    PunchlistPhotoItem = "PunchlistPhotoItem",
}
